import { createAction } from '@sde/widgets-core/src/redux/helpers/createAction';
import { TOGGLE_MODAL } from './constants';

export const toggleModal = (payload) => {
  return createAction({
    type: TOGGLE_MODAL,
    payload,
  });
};
